export const DEFAULT_MAX_LENGTH = 5000;
const WARNING_THRESHOLD = 0.98;
const WARNING_CLASS = 'sd-character-counter--warning';

/**
 * Renders a character counter for the "other" text field in radiogroup, checkbox, and dropdown questions.
 * SurveyJS enforces the hard limit via model.maxOthersLength; this only adds the visual counter.
 * @param {HTMLElement} container - The question's root DOM element.
 * @param {object} question - The SurveyJS question model.
 * @returns {boolean} - Returns true if the counter was attached.
 */
export function renderOtherFieldCounter(container, question) {
  const otherText = container.querySelector('.sd-selectbase__other');
  if (!otherText || otherText.dataset.counterInit) return false;
  otherText.dataset.counterInit = 'true';

  const maxLength = question.jsonObj?.maxLength || DEFAULT_MAX_LENGTH;
  const warnAt = Math.floor(maxLength * WARNING_THRESHOLD);

  const counter = document.createElement('div');
  counter.className = 'sd-character-counter';
  otherText.parentNode.appendChild(counter);

  const update = () => {
    const length = otherText.value.length;
    counter.textContent = `${length}/${maxLength}`;
    counter.classList.toggle(WARNING_CLASS, length >= warnAt);
  };

  update();
  otherText.addEventListener('input', update);
  return true;
}

/**
 * Attaches an input listener to text/comment questions to toggle a warning class
 * on the built-in SurveyJS character counter when approaching the limit.
 * @param {object} options - The options object provided by SurveyJS onAfterRenderQuestion.
 */
export function initBuiltInCounterWarning(options) {
  const type = options.question.getType();
  if (type !== 'text' && type !== 'comment') return;

  const input = options.htmlElement.querySelector('.sd-input');
  if (!input || input.dataset.warningInit) return;
  input.dataset.warningInit = 'true';

  const question = options.question;
  const maxLength = question.maxLength > 0 ? question.maxLength : (question.survey?.maxTextLength || DEFAULT_MAX_LENGTH);
  const warnAt = Math.floor(maxLength * WARNING_THRESHOLD);

  const update = () => {
    const counter = options.htmlElement.querySelector('.sd-remaining-character-counter');
    if (counter) {
      counter.classList.toggle(WARNING_CLASS, input.value.length >= warnAt);
    }
  };

  input.addEventListener('input', update);
}
